/**
 * Sentry DOM attributes that are preserved on elements
 */
export interface SentryAttributes {
    /** The React component name */
    component?: string;
    /** The source file path */
    sourceFile?: string;
    /** The element name (e.g., 'Button', 'Input') */
    element?: string;
}

/**
 * Information about an inspected element
 */
export interface InspectedElement {
    /** The clicked element */
    element: Element;
    /** Bounding rectangle of the element */
    rect: DOMRect;
    /** Sentry attributes found on this element or ancestors */
    sentryAttributes: SentryAttributes;
    /** The ancestor element with Sentry attributes (if different from clicked element) */
    sentryAncestor: Element | null;
}

/**
 * State of the element inspector
 */
export type InspectorState = 'inactive' | 'active';

/**
 * Sentry attribute names as they appear in the DOM
 */
export const SENTRY_ATTR_NAMES = {
    COMPONENT: 'data-sentry-component',
    SOURCE_FILE: 'data-sentry-source-file',
    ELEMENT: 'data-sentry-element',
} as const;

/**
 * Array of all Sentry attribute names for easy iteration
 */
export const SENTRY_ATTRS = [
    SENTRY_ATTR_NAMES.COMPONENT,
    SENTRY_ATTR_NAMES.SOURCE_FILE,
    SENTRY_ATTR_NAMES.ELEMENT,
] as const;
